export enum FormFileModes {
  SENT_TO_CLIENT = 'SENT_TO_CLIENT',
  MAKE_VISIBLE_TO_CLIENT = 'MAKE_VISIBLE_TO_CLIENT',
}
